import styled from 'styled-components'
import { Card } from 'react-bootstrap'

export const RootContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background-color: #1e1e1e;
  z-index: 1;
`

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow-x: hidden;
  background-color: #1a1a1a;
`

export const NavbarContainer = styled.div`
  height: 6vh;
  width: 100%;
  flex-shrink: 0;
  position: relative;
  z-index: 1001;
`

export const HeaderContainer = styled.div`
  margin-left: 4.5rem;
  padding: 1rem;
  width: calc(100% - 4.5rem);
  z-index: 1;
  background-color: #1a1a1a;
  position: relative;
`

export const MainContentContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 5.5rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  background-color: #1a1a1a;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`

export const ProjectCard = styled(Card)`
  background-color: #1a1a1a;
  border: none;
  width: 100%;

  .card-header {
    color: white;
    padding: 0;
  }
`
